export default "__VITE_ASSET__BZWtE7Z2__"